export default {
    agentLoading: false,
    agentsListLoading: false,
    agentsList: [],
    selectedAgent: {}
}